import type { AccountType, Notification } from '@witmetrics/utils';
import { ACCOUNT_TYPES } from '@witmetrics/utils/constants';
import {
  fetchProjectLead as coreFetchProjectLead,
  fetchRecents as coreFetchRecents,
  updateActiveAccount as coreUpdateActiveAccount,
  updateReadNotification as coreUpdateReadNotification,
} from '@witmetrics/unison-core';
import { API } from '@/api';
import { useSessionStorage } from '@/hooks/useStorage';

const { PRACTICE, LAB } = ACCOUNT_TYPES;

export function useStoredAccountId() {
  return useSessionStorage<number | null>('activeAccountId', null, true);
}

export const updateActiveAccount = (
  accountType: AccountType,
  accountId: number
) => coreUpdateActiveAccount(API, accountType, accountId);

export const updateReadNotification = (notificationId: number) =>
  coreUpdateReadNotification(API, notificationId);

export const fetchProjectLead = (projectId: number) =>
  coreFetchProjectLead(API, projectId);

export const fetchRecents = () => coreFetchRecents(API);

export function warnBeforeUnload(e: BeforeUnloadEvent) {
  e.preventDefault();
  e.returnValue = '';
}

export function getNotificationAccount(notification: Notification) {
  if (notification.practiceId) {
    return { accountType: PRACTICE, accountId: notification.practiceId };
  }
  return { accountType: LAB, accountId: notification.labId! };
}
